import { getConfig } from "./config";

const config = getConfig();
const root = document.documentElement;

root.style.setProperty('--primary-color', config.brand.theme.primary || '#000000');
root.style.setProperty('--banner-dark-logo', `url(${config.brand.logo.dark})`);
root.style.setProperty('--secondary-color', config.brand.theme.secondary || 'rgb(2, 3, 129)');
root.style.setProperty('--main-color', config.brand.theme.main || '#ffffff');
root.style.setProperty('--link-color', config.brand.theme.link || '#63B3ED');
